import React, { useState, useRef, useEffect, useMemo } from "react";
import {TextField,
        Grid,
        Typography,
        Chip
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';
import useStyles from './styles'
const autocompleteService = { current: null };
const geocodeService = { current: null };

export default function MultiSelectAutoComplete(props) {
    const { presetValue, options, label, idName, displayName, groupByName,
            renderOption, renderTags, menuHeight } = props
    const classes = useStyles();
    const [value, setValue] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const loaded = useRef(false);
    const [tagSize, setTagSize] = useState(props.tagSize ? props.tagSize : 'small');


    useEffect(() => {
        setValue(presetValue ?? []);
    }, [presetValue]);


  return (options !== undefined && options !== null && options.length > 0 &&
            <Autocomplete
              multiple
              id="field-to-complete"
              style={{ background: 'white' }}
              renderOption={renderOption}
              getOptionLabel={(option) => (option === undefined || option === null ? '' : (typeof option === 'string' ? option : option[displayName]))}
              options={options}
              value={value}
              //defaultValue={presetValue ?? []}
              noOptionsText="Type to search"
              filterSelectedOptions
              groupBy={(option) => option[groupByName]}
              onChange={(event, newValue) => {setValue(newValue);
                if (newValue !== undefined && newValue !== null) {//console.log('onChange', event, newValue);
                  props.onSelect(newValue);
                }

              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              ListboxProps={{
                    style: {
                       maxHeight: menuHeight ? menuHeight: 'auto',
                          },
                    }}
              renderTags={renderTags !== undefined || renderTags !== null ? renderTags :
                ((value, getTagProps) =>
                  value.map((option, index) => (
                      <Chip
                        variant="outlined"
                        label={option.title}
                        size={tagSize}
                        {...getTagProps({ index })}
                      />
                  )))
              }
              renderInput={(params) => (
                <TextField {...params} label={label}
                                       variant="outlined"
                                       required={props.required ? props.required : false}
                                       inputProps={{
                                          ...params.inputProps,
                                       }}
                                        />
              )}
            />

  );
}
